<template>
  
    <v-card
      title="Formulaire"
      flat
      v-if="store.state.user.token&&groupe.find(g=>g==store.state.user.groupe)"
    >
    <v-progress-linear  v-if="store.state.waiting"  color="antiquewhite" indeterminate></v-progress-linear>
    <v-divider></v-divider>
        <v-row >
              <v-col cols="1"><v-text-field  label="Num Fripe" variant="outlined" v-model="singleRec"></v-text-field></v-col>
              <v-col cols="1"><v-btn v-if="singleRec&&singleRec!=''" color="warning" @click="getSingleReception()">Importer</v-btn></v-col>
              <v-col cols="1"><v-btn v-if="singleRec&&singleRec!=''"  color="primary" @click="exportDialog=true">Exporter</v-btn></v-col>
              <v-col cols="2"><JsonToExcel v-if="singleRec&&singleRec!=''"  ></JsonToExcel></v-col>
        </v-row>
        <v-divider></v-divider>
      <DialogCodeArticle  :terminer></DialogCodeArticle>
      <v-table height="600">
        <thead>
            <tr >
                <th>Action</th>
                <th v-for="item in headers"
                :key="item.name">{{ item.title }}
                </th>
            </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in store.state.articlesFripe.sort((a, b) => a.marque - b.marque)"
                    :key="item"
          >
            <td>
              <v-btn-group :disabled="terminer" color="#b2d7ef" density="comfortable">
                <v-icon icon="$error" size="small" color="error" @click="deleteDialog=true;supprimer(item)"></v-icon><span> </span>
                <v-icon icon="$info" size="small" color="warning" @click="editDialog=true;modifierPopUp(item)"></v-icon>
                <v-icon icon="$success" size="small" color="success" @click="duppliquer(item)"></v-icon>
              </v-btn-group>
            </td>
            <td>SecondLife</td>
            <td>Coralie</td>
            <td>{{ item.marque }}</td> 
            <td>{{ item.theme }}</td>
            <td>{{ item.refFourn }}</td>
            <td>{{ item.nomProduit }}</td>
            <td>{{ item.composition }}</td>
            <td>€<input type="text" :value="item.prixPublicTTC" size="2" @change="modifier($event.target.value,item.id,'prixPublicTTC')"> </td>
            <td>{{ item.sousFamille }}</td>
            <td>{{ item.libCouleur }}
              <!-- <select @change="modifier($event.target.value,item.id,'libCouleur')"> 
                  <option > {{ item.libCouleur }}
                  </option>
                  <option v-for="el in itemsColor" :style="getColor(el)">{{ el }}
                  </option>
              </select> -->
            </td>
            <td>€<input type="text" :value="item.prixAchatHT" size="4" @change="modifier($event.target.value,item.id,'prixAchatHT')"> </td>
            <td><input type="text" :value="item.qteCommande" size="4" @change="modifier($event.target.value,item.id,'qteCommande')"> </td>
            <td>{{ item.poidnet }}</td>
            <td>{{ item.dimensions }}</td>
            <td>{{ item.litrage }}</td>
            <td>{{ item.codeFournisseur }}</td>
            <td>{{ item.remarque }}</td>
            <td  size="2">€ {{ Number(item.totalBrut).toFixed(2) }}</td>
            <td  size="2">{{ Number(item.coefBrut).toFixed(2) }}</td>
            <td  size="2">€ {{ Number(item.totalPVpublic).toFixed(2) }}</td>
          </tr>
          <tr>
            <td><h6>Total</h6> </td>
            <td v-for="i in 11"
                :key="i">
            </td>
            <td><h6>{{sum(store.state.articlesFripe,"qteCommande")}}</h6></td>
            <td v-for="i in 5"
                :key="i">
            </td>
            <td><h6>€ {{sum(store.state.articlesFripe,"totalBrut").toFixed(2)}}</h6></td>
            <td><h6>{{sum(store.state.articlesFripe,"totalBrut")!=0?(sum(store.state.articlesFripe,"totalPVpublic")/sum(store.state.articlesFripe,"totalBrut")).toFixed(2):0}}</h6></td>
            <td><h6>€ {{sum(store.state.articlesFripe,"totalPVpublic").toFixed(2)}}</h6></td>
          </tr>
        </tbody>
      </v-table>
    <div class="text-center pa-4">
      <v-btn @click="validerArticles();terminer=true;dialogFinale=true" color="success" :disabled="terminer" >
      Valider 
      </v-btn>
      <v-dialog
          v-model="dialogFinale"
          width="auto"
      >
          <v-card
          max-width="400"
          prepend-icon="mdi-update"
          :text="`La reception numéro: ${store.state.numeroBon} a été créé correctement. Elle est encours de traitement auprès de notre service d'expertise`"
          title="Vérification en cours"
          >
          <template v-slot:actions>
              <v-btn
              class="ms-auto"
              text="Ok"
              @click="dialogFinale = false"
              ></v-btn>
          </template>
          </v-card>
      </v-dialog>
    </div>
    <v-btn @click="NouvelleReception()"  color="warning" style="display:block;margin: auto;">
        Nouvelle Reception
    </v-btn>
    </v-card>
    <Supprimer v-model="deleteDialog" :itemtoDelete></Supprimer>
    <Modifier v-model="editDialog" :itemtoEdit></Modifier> 
    <div class="text-center pa-4">
      <v-dialog
        v-model="exportDialog"
        width="auto"
      >
        <v-card
          max-width="400"
          prepend-icon="$error"
          text="Vous voulez vraiment exporter la réception?"
          title="Export"
        >
          <template v-slot:actions>

            <v-card-actions>
                <v-btn
                    text="Annuler"
                    @click="exportDialog = false"
                    variant="plain"
                    color="red"
                ></v-btn>
                <v-btn
                    color="green"
                    text="Exporter"
                    @click="exportReception();exportDialog = false"
                    variant="plain"
                ></v-btn>
            </v-card-actions>  
          </template>
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center pa-4">
      <v-dialog
          v-model="fripeNotExist"
          width="auto"
      >
          <v-card
          max-width="400"
          prepend-icon="$error"
          :text="`La reception numéro ${singleRec} n'existe pas`"
          title="Pas de réception"
          >
          <template v-slot:actions>
              <v-btn
              class="ms-auto"
              text="Ok"
              @click="fripeNotExist = false"
              ></v-btn>
          </template>
          </v-card>
      </v-dialog>
    </div>
</template>
<script setup>
import store from './store'
import DialogCodeArticle from './DialogCodeArticle.vue'
import Supprimer from './Supprimer.vue'
import axios from 'axios'
import { ref,onMounted } from 'vue'
import Modifier from './Modifier.vue'
import JsonToExcel from './JsonToExcel.vue'
import router from './router'
let groupe=ref(['A','B'])
let dialogFinale=ref(false)
let itemtoDelete=ref()
let itemsColor=store.state.itemColors
let itemtoEdit=ref()
const supprimer=(item)=>{
    itemtoDelete=item
}
const modifierPopUp=(item)=>{
    itemtoEdit.value={...item,oldId:item.id,oldcouleur:item.libCouleur} 
}
let sum=(object,value)=>{
  let sum=0
  for(let key in object){
    sum=sum+(object[key][value]?Number(object[key][value]):0)
  } 
  return sum
 }
const getColor=(item)=>{
  switch(item.substring(0,2)){
    case 'AA': return { 'color':'white', 'background-color':'black'}
      break
      case 'AB': return { 'color':'white','background-color':'blue'}
      break
      case 'AC': return {'background-color':'grey'}
      break
      case 'AD': return {}
      break
      case 'AE': return {'background-color':'white'}
      break
      case 'AF': return {'background-color':'beige'}
      break
      case 'AG': return {'background-color':'#483C32'}
      break
      case 'AH': return {'background-color':'#C19A6B'}
      break
      case 'AI': return {'background-color':'brown'}
      break
      case 'AJ': return {'color':'white','background-color':'red'}
      break
      case 'AK': return {'background-color':'orange'}
      break
      case 'AL': return {'background-color':'pink'}
      break
      case 'AM': return {'color':'white','background-color':'purple'}
      break

  }
  'AA-BLACK',	'AB-BLUE',	'AC-GREY',	'AD-MULTICOLOR',	'AE-WHITE',	'AF-BEIGE',	'AG-TAUPE',	'AH-CAMEL',	'AI-BROWN',	'AJ-RED',	'AK-ORANGE',	'AL-PINK',	'AM-PURPLE'
}

let deleteDialog=ref(false)
let terminer=ref(false)
let exportDialog=ref(false)
let singleRec=ref()
let fripeFile=ref()
let fripeNotExist=ref()
let editDialog=ref(false)
    let headers=ref([
    { key: 'pole', title: 'Pôle' },
    { key: 'acheteur', title: 'Acheteur' },
    { key: 'marque',title: 'Marque'},
    { key: 'theme', title: 'Thème' },
    { key: 'refFourn', title: 'Ref_Fourn' },
    { key: 'nomProduit', title: 'Nom_Produit' },
    { key: 'composition', title: 'Composition' },
    { key: 'prixPublicTTC', title: 'Prix_Public_TTC' },
    { key: 'sousFamille', title: 'Sous_Famille' },
    { key: 'libCouleur', title: 'Lib_Couleur' },
    { key: 'prixAchatHT', title: 'Prix_Achat_HT' },
    { key: 'qteCommande', title: 'Qte_Commande' },
    { key: 'poidnet', title: 'PoidsNet' },
    { key: 'dimensions', title: 'Dimensions_L*H*P' },
    { key: 'litrage', title: 'Volume' },
    { key: 'codeFournisseur', title: 'Code_Fournisseur' },
    { key: 'remarque', title: 'Remarque_Acheteur' },
    { key: 'totalBrut', title: 'Total_Brut' },
    { key: 'coefBrut', title: 'Coef_Brut' },
    { key: 'totalPVpublic', title: 'Total_PVPublic' },  
    ]) 

    // const duppliquer=(item)=>{
    //     store.commit('addRowArticle',{...item,id:'FRI-'+(store.state.countId++).toString().padStart(8,"0")})
    // }
    const modifier=(value,id,champs)=>{
        store.commit('editRowArticle',{'value':value,'id':id,'champs':champs})
    }
  const NouvelleReception=()=>{
    terminer.value=false
    fripeFile=ref()
    singleRec=ref()
    store.commit('addClient',[]) 
    store.commit('deleteArticles')
    if(store.state.codeFournisseur.updated){
      store.commit('updateCodeFournisseur','951263')
    }
    
  }
    
  async  function validerArticles(){
    if(!fripeFile.value){
      await getNumBon()
    }
    let data ={ 
      title:'DEPO-'+store.state.numeroBon,
      reception:{etablissement:'DEPO',vendeur:'',numeroBon:store.state.numeroBon,etat:'encours',informations:'',type:'FRIPE'},
      client:{
              "tiers":"DEPO",
              "firstname":'',
              "lastname":'',
              "email":'',
              "telephone":'',
              "telex":'',
              "adesse":'',
              "codePostal":'',
              "ville":'',
              "pays":'',
              "sexe":'',
              "choixReprise":''
          },
      articles:store.state.articlesFripe,
      photos:{
        signature:'',
        photos:''
      },
      file:(fripeFile.value?fripeFile.value:'')
    }
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/recordsfripe',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    }
    return axios.request(config)
    .then((response) => { 
    })
    .catch((error) => {
    //console.log(error);
    });
 }
 async  function exportReception(){
    let data ={ 
      title:'DEPO-'+store.state.numeroBon,
      reception:{etablissement:'DEPO',vendeur:'',numeroBon:store.state.numeroBon,etat:'encours',informations:''},
      client:{
              "tiers":"DEPO",
              "firstname":'',
              "lastname":'',
              "email":'',
              "telephone":'',
              "telex":'',
              "adesse":'',
              "codePostal":'',
              "ville":'',
              "pays":'',
              "sexe":'',
              "choixReprise":''
          },
      articles:store.state.articlesFripe,
      photos:{
        signature:'',
        photos:''
      }
    }
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/exportreception',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    }
    return axios.request(config)
    .then((response) => {     
    })
    .catch((error) => {
    //console.log(error);
    });
 }


 function getNumBon(){  
    let url=    `https://my.edisac.com/api/numbon`
    let config = {
    method: 'get',
    url: url
    };
    return   axios.request(config)
    .then((response) => {
        store.commit('addNumBon',response.data)
        singleRec.value=response.data
    })
    .catch((error) => {
    //console.log(error);
    });
  }

  const sendNumBon=()=>{
    
    let data = {numbon:store.state.numeroBon+1}
    
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/numbon',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    }
    return axios.request(config)
    .then((response) => { 
    })
    .catch((error) => {
    //console.log(error);
    });
  }

  function getSingleReception(){  
    store.commit('updateComponent',router.currentRoute.value.name)
    let url=    `https://my.edisac.com/api/singlereception`
    let config = {
    method: 'get',
    url: url,
    params:{numrec:singleRec.value}
    };
    return   axios.request(config)
    .then((response) => {
      if(response.data.exist){
        store.commit('addReception',response.data.articles)
        store.commit('addNumBon',response.data.reception.numeroBon)
        store.commit('updateComponent',router.currentRoute.value.name)
        fripeFile.value=response.data.file
        terminer.value=false
      }else{
        fripeNotExist.value=true
      }
    })
    .catch((error) => {
    //console.log(error);
    });
  }
  const duppliquer=(item)=>{
    let data ={article:item}
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/getArticle',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    }
    return axios.request(config)
    .then((response) => { 
      store.commit('addRowArticle',response.data[0])
    })
    .catch((error) => {
    //console.log(error);
    });
  }

    
  onMounted(() => {


  })

</script>